import { useTranslation } from 'react-i18next'

const LeagueStart = (props) => {
  const { t } = useTranslation()
  
  return (
    <svg
      role="image"
      aria-labelledby="league-end-title"
      viewBox="0 0 1920 1080"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <title id="league-end-title">{t('antagonists:league:components:end')}</title>
      <defs>
        <clipPath id="league-b">
          <path
            d="M123.4 111.51c-8.07.79-29.99.78-35.05 36.2-5.06 35.42-13.84 53.8-2.71 65.44 11.13 11.64 14.99 26.37 14.99 26.37s9.01-1.76 15.07-15.93c6.07-14.17-9-43.27-4.45-63.51s8.6-33.9 13.15-32.89c4.55 1.01 16.68 11.3 25.29 28.67s.22 30.16-.5 42.17c-1.4 23.21 17.68 40.06 17.68 40.06s1.13-9.96 9.73-29.18-1.8-30.4-8.38-60.75c-6.58-30.36-19.02-39.18-44.83-36.65Z"
            style={{
              fill: 'none',
            }}
          />
        </clipPath>
        <clipPath id="league-c">
          <path
            d="M135.69 201.74c-13.58 1.66-32.35-3.68-34.31-25.33-1.96-21.65 8.4-28.78 13.02-36.27 5.28-8.57 4.37-13.25 11.75-13.99s6.9 2.41 16.52 15.77 15.56 18.84 16.23 31.35c.67 12.49-10.32 26.91-23.23 28.48Z"
            style={{
              fill: 'none',
            }}
          />
        </clipPath>
        <clipPath id="league-d">
          <path
            d="M1860.63 712.97c13.41 1.82 12.2 7.25 13.92 10.51 1.72 3.26 13.92 26.47 15.63 31s2.67 12.33 2.1 13.78c-.57 1.45-10.68 3.99-21.73 3.63-11.06-.36-16.97-.18-20.59-1.81s.76-11.6.76-18.13-4-11.78-4.77-18.31c-.76-6.53-.95-10.15-.95-10.15s5.34-.91 6.1-3.26c.76-2.36 1.53-8.34 9.53-7.25Z"
            style={{
              fill: 'none',
            }}
          />
        </clipPath>
        <clipPath id="league-e">
          <path
            d="M1787.17 711.26c9.52-.71 10.29 7.25 13.15 8.16s4 3.44 4.58 9.79c.57 6.34 4.58 27.19 3.62 31.54-.95 4.35-2.1 5.98-7.82 5.98s-25.17-.54-29.93-.54-5.72-5.08-5.34-11.42c.38-6.34 5.15-17.77 7.63-23.57s.76-9.25 2.86-12.69 4-6.71 11.25-7.25Z"
            style={{
              fill: 'none',
            }}
          />
        </clipPath>
        <clipPath id="league-f">
          <path
            d="M1766.5 272.67s5.37 24.41 2.73 31.2-10.97 6.57-10.97 6.57l13.95 39.78 62.22-8.86-1.13-34.88s-18.58-2.03-22.33-10.2c-3.76-8.17-.06-21.61-.06-21.61l-44.4-2.01Z"
            style={{
              fill: 'none',
            }}
          />
        </clipPath>
        <clipPath id="league-g">
          <path
            d="M1722.26 328.89s10.48 71.18 9.36 98.11c-1.13 26.93-4.95 33.6-9.67 57.55-4.17 21.15 5.35 34.95 5.35 34.95l4.04 16.08s44.22-1.87 72.96-4.86 67.56-17.33 67.56-17.33l-1.35-17.7s8.8-4.06 6.09-23.02c-6.99-48.95-20.32-145.37-25.08-152.43-6.2-9.21-28.67-18.19-28.67-18.19s-7.66 9.25-14.61 18.77-13.27 24.92-13.27 24.92-10.23-13.43-20.08-22.06-19.67-19.51-19.67-19.51l-32.97 24.71h.01Z"
            style={{
              fill: 'none',
            }}
          />
        </clipPath>
        <clipPath id="league-h">
          <path
            d="M1257.26 869.33c4.76-1.26 3.71 15.34 5.09 24.6 1.3 8.75 3 16.11 3 16.11s-21.92 6.5-24.19 9.42c-2.27 2.92-7.06 6.32-15.9 7.54-8.83 1.22-28.26-.49-29.77-3.16s-2.58-12.73 4.99-17.83c7.57-5.11 14.94-13.29 17.47-18.15 2.52-4.86 3.78-23.34 15.39-21.64s15.14 15.08 19.18 13.37 2.8-9.73 4.75-10.25h-.01Z"
            style={{
              fill: 'none',
            }}
          />
        </clipPath>
        <clipPath id="league-i">
          <path
            d="M1329.6 913.06s10.29 3.26 12.17 7.56 1.88 7.69 13.38 8.82 26.46-.65 30.45-3.14 2.53-11.72.21-16.03c-3.38-6.26-14.88-12.65-17.28-19.52-2.72-7.8-4.46-24.21-15.02-22.62-10.56 1.58-10.09 12.44-14.09 13.57-3.99 1.13-4.23-3.62-4.23-3.62s-4.7 20.36-4.7 26.7-.9 8.28-.9 8.28h.01Z"
            style={{
              fill: 'none',
            }}
          />
        </clipPath>
        <style>
          {
            '.j{fill:none}.k{fill:#f4d027}.l{fill:#006835}.m{fill:#009250}.n{fill:#e6f1e2}.o{fill:#fdd900}.p{fill:#e8af34}.q{fill:#ef8227}.r{fill:#ebc88b}.s{fill:#e2e6ea}.t{fill:#ea683e}.u{fill:#c48648}.v{fill:#ad5850}.w{fill:#c6a4c9}.x{fill:#e2a972}.y{fill:#e29b7b}.aa{fill:#3fa25a}.ab{fill:#a3853f}.ac{fill:#54535e}.ad{fill:#284f4f}.ae{fill:#2e425b}.af{fill:#3a4b36}.ag{fill:#272a3e}.ah{fill:#4f4e47}.ai{fill:#4f6a6a}.aj{clip-path:url(#league-c)}.ak{clip-path:url(#league-b)}.al{clip-path:url(#league-f)}.am{clip-path:url(#league-e)}.an{clip-path:url(#league-d)}.ao{clip-path:url(#league-i)}.ap{clip-path:url(#league-h)}.aq{clip-path:url(#league-g)}'
          }
        </style>
      </defs>
      <path
        d="M213.68 272.3s7.59 57.55 6.5 67.4-35.35 49.46-35.35 49.46-23.97-48.97-22.88-49.34 22.44-59.25 22.44-59.25l29.29-8.28ZM49.65 290.16s-1.67 55.79 2.44 64.16c4.11 8.36 31.3 30.3 39.79 29.23s-3.32-48.49-2.53-59.38c.8-10.89-4.17-38.52-8.15-41.17-3.98-2.65-33.01-5.32-31.55 7.15Z"
        style={{
          fill: '#e2a972',
        }}
      />
      <path
        d="M143.27 323.01 85.5 334.07s-22.12 76.81-10.45 131.5c11.67 54.69 18.44 59.6 17.21 76.2s3.07 58.38 7.37 79.89c4.3 21.51 15.97 49.16 15.97 49.16l31.96-3.07s-12.9-80.5-9.83-95.86c3.07-15.36 5.53-33.18 10.45-58.38 4.92-25.19-4.92-190.49-4.92-190.49Z"
        style={{
          fill: '#54535e',
        }}
      />
      <path
        d="M168.66 337.24s38.03 61.74 47.15 93.65c9.12 31.91 5.84 103.92 8.77 123.72 2.44 16.51 11.88 54.84 15.71 71.63 3.83 16.79 9.4 40.56 9.4 40.56l-31.05 4.32s-29.53-61.08-34.9-81.28c-5.37-20.19-6.76-49.88-12.01-62.47-5.25-12.59-69.94-155.22-69.94-155.22s69.96-37.65 66.87-34.91Z"
        style={{
          fill: '#54535e',
        }}
      />
      <path
        d="M128.21 662.44c-6.2.52-19.06 0-19.06 0s10.67 22.43 10.41 31.47c-.13 4.43-4.24 12.02-4.65 19.12-.43 7.4-2.2 13.59-2.2 13.59l10.99 4.5 7.74-2.29s5.9 6.56 14.74 8.5c12.81 2.8 34.36-2.06 34.36-2.06s.74-13.75-8.79-16.53c-10.59-3.1-13.69-11.11-17.83-24.03-4.14-12.92-6.46-38.5-6.46-38.5s-6.84 5.22-19.24 6.25ZM208.25 654.39l21.33-4.24 7.79 12.03s-1.76-14.4 9.44-16.98c4.67-1.07 4.4 5.08 4.4 5.08s-.8 19.25 2.04 28.53c1.99 6.52 7.75 16.1 16.23 17.84 8.49 1.76 19.14-2.72 22.83 1.11 3.69 3.83 5.76 12.29 5.76 12.29s-4.53 4.57-18.83 8.1c-14.3 3.54-20.66 4.71-24.05 2.62-3.61-2.22-6.66-1.5-6.66-1.5s-3.32 4.71-4.06 4.9c-.75.2-25.5 1.33-25.5 1.33s-1.11-6.36.06-21.1c1.16-14.75.13-21.15-2.15-26.7s-8.63-23.32-8.63-23.32ZM78.83 407.24s-5.37 28.59-8.95 42c-3.2 12.01.14 38.89.14 38.89s19.18-7.41 60.07-12.81c40.88-5.41 43.84 1.39 68.82-1.38 18.71-2.08 28.05-6.45 28.05-6.45s-1.42-42.01-4.42-52.23c-3.01-10.22-10.22-27.66-10.22-27.66L78.85 407.25Z"
        style={{
          fill: '#272a3e',
        }}
      />
      <path
        d="M122.8 206.08c-26.09 1.19-41.11 10.12-53.49 17.35-7.97 4.65 6.5 35.91 6.5 49.86s-7.5 82.96-8.8 101.13c-1.3 18.17-1.98 62.11-1.98 62.11s61.07 1.93 97.41-2.94 67.59-24.29 67.59-24.29-20.8-43.34-27.29-69.29-4.22-46.26-3.25-69.29c.98-23.04 3.86-44.89-3.6-50.41s-46.93-15.4-73.09-14.22Z"
        style={{
          fill: '#e6f1e2',
        }}
      />
      <path
        d="M186.92 218.99c-8.72 1.02-8.26 33.21-6.63 48.46s1.41 43.9 1.41 43.9 17.85-12.24 27.92-10.62c10.06 1.63 23.52-4.62 23.52-4.62s-8.58-23.01-18.64-47.35-16.53-31.06-27.57-29.76ZM53.32 236.84C49.51 243.71 39.48 305 39.48 305s18.22 4.67 27.31 8.89c9.09 4.22 26.54-6.52 26.54-6.52l-14.62-88.84s-20.52 9.57-25.39 18.33Z"
        style={{
          fill: '#e6f1e2',
        }}
      />
      <path
        d="M107.55 176.95s2.57 15.2 1.53 20.89c-1.03 5.69-8.81 12.01-8.81 12.01s3.2 16.82 32.84 14.41c27.44-2.23 28.83-16.02 28.83-16.02s-9.36-2.32-9.36-10.09.52-22.26.52-22.26-44.51 0-45.55 1.03v.02Z"
        style={{
          fill: '#e2a972',
        }}
      />
      <path
        d="M123.4 111.51c-8.07.79-29.99.78-35.05 36.2-5.06 35.42-13.84 53.8-2.71 65.44 11.13 11.64 14.99 26.37 14.99 26.37s9.01-1.76 15.07-15.93c6.07-14.17-9-43.27-4.45-63.51s8.6-33.9 13.15-32.89c4.55 1.01 16.68 11.3 25.29 28.67s.22 30.16-.5 42.17c-1.4 23.21 17.68 40.06 17.68 40.06s1.13-9.96 9.73-29.18-1.8-30.4-8.38-60.75c-6.58-30.36-19.02-39.18-44.83-36.65Z"
        style={{
          fill: '#272a3e',
        }}
      />
      <g
        style={{
          clipPath: 'url(#league-b)',
        }}
      >
        <path
          d="M116.95 97.24s7.53 11.45 8.34 19.98c.81 8.54-.14 13.36-.14 13.36l2.15.09s.93-8.13-.11-14.38-6.36-18.23-6.36-18.23-3.91-.51-3.89-.83Z"
          style={{
            fill: '#e2a972',
          }}
        />
      </g>
      <path
        d="M135.69 201.74c-13.58 1.66-32.35-3.68-34.31-25.33-1.96-21.65 8.4-28.78 13.02-36.27 5.28-8.57 4.37-13.25 11.75-13.99s6.9 2.41 16.52 15.77 15.56 18.84 16.23 31.35c.67 12.49-10.32 26.91-23.23 28.48Z"
        style={{
          fill: '#e2a972',
        }}
      />
      <g
        style={{
          clipPath: 'url(#league-c)',
        }}
      >
        <path
          d="M124.34 147.5s-6.12-.59-9.86 1.26c-4.29 2.12-4.27 2.89-4.27 2.89l.97 1.85s2.92-1.19 4.62-1.64c3.91-1.04 9.21-1.21 9.21-1.21s-.5-3.41-.67-3.14ZM137.33 145.88s4.46-.93 8.07-.31c3.61.61 5.78 3.27 5.78 3.27l-1.07 2.28c-.11 0-2.14-1.45-4.52-1.74-2.22-.28-8.76-.33-8.76-.33s.3-3.42.5-3.17Z"
          style={{
            fill: '#a3853f',
          }}
        />
      </g>
      <path
        d="M134.77 179.33c.96.19 2.32-2.54 5.7-.72 3.38 1.83 5.5 3.35 5.15 4.24-.36.89-6.81 5.31-16.51 4.96-3.71-.13-5.88-5.29-6.09-6.61s4.32-2.66 7.75-2.93c3.44-.27 3.85 1.02 4.02 1.06Z"
        style={{
          fill: '#ef8227',
        }}
      />
      <path
        d="m119.4 159.84-6.63 1.85-.18-1.9 7.24-2.24s-.28 2.28-.43 2.29Z"
        style={{
          fill: '#2e425b',
        }}
      />
      <path
        style={{
          fill: '#2e425b',
        }}
        d="m119.74 157.8-3.98-4.17 1.15-1.19 3.75 3.65-.92 1.71z"
      />
      <path
        d="M119.04 155.39c-1.72.99-2.25 2.85-1.21 4.48 1.03 1.64 2.56 2.21 4.15 1.42 1.88-.93 2.26-2.89 1.37-4.68-.63-1.27-2.54-2.24-4.31-1.23ZM141.84 158.49l7.08 1.75.58-2.16-7.77-1.8s-.05 2.2.11 2.22ZM142.1 156.25l3.95-3.89-1.08-1.19-3.71 3.42.84 1.66z"
        style={{
          fill: '#2e425b',
        }}
      />
      <path
        d="M142.68 154.17c1.68 1.04 2.17 2.9 1.09 4.51-1.08 1.61-2.74 1.75-4.31.91-1.85-.98-2.06-2.55-1.12-4.32.67-1.25 2.61-2.17 4.34-1.11Z"
        style={{
          fill: '#2e425b',
        }}
      />
      <path
        d="M1775.29 204.81c-16.06 4.54-25.8 16.83-26.74 28.03s-13.22 21.51-13.22 21.51-.27 2.9 5.19 2.24c1.87-.23 3.78-2.19 4.73.95.94 3.14-8.03 2.19-8.03 13.39s9.31 14.35 15.78 19.91c5.53 4.75 4.11 4.85 12.29 10.91 9.94 7.36 39.38-1.82 39.38-1.82s19.25-1.18 22.73-14.66c1-3.89 5.67-1.34 5.67-1.34s6.14-12.1 0-21.06-5.07-14.06-5.07-19.89 6.95-17.76-7.68-25.83c-14.64-8.07-36.71-14.7-45.03-12.34Z"
        style={{
          fill: '#e8af34',
        }}
      />
      <path
        d="M1789.37 300.18c-19.62.46-49.28-6.93-50.14 3.67-1.22 15.03 9.81 37.61 6.86 20.11l87.3.15s11.8-17.4.77-27.8c-8.36-7.89-29.87 3.51-44.79 3.86Z"
        style={{
          fill: '#4f6a6a',
        }}
      />
      <path
        d="M1760.52 267.8s-6.45-2.01-7.04 2.07c-.98 6.68 1.33 13.39 4.24 13.39s3.76-.67 3.76-.67 1.11 6.7 4.6 9.53c3.49 2.84 15.36 9.56 25.25 8.71s18.09-7.93 20.7-11.62c2.62-3.69 2.75-9.93 2.75-9.93s5.02.58 6.76-1.69c1.75-2.27 3.32-10.81.56-11.9-4.1-1.61-7.78 0-7.78 0s-5.94-9.61-9.72-14.72c-3.78-5.11-17.78-3.89-28.06-8.33-6.86-2.97-9.79 6.01-9.72 12.78.08 8.88-6.29 12.37-6.29 12.37ZM1905.54 438.16s-13.28 29.08-12.02 35.62c1.75 9.09-.27 42.64-.87 45.2-1.84 7.83-10.55 19.03-10.55 19.03s-2.45-2.68-2.31-5.19c.25-4.36 2.32-6.53 3.61-9.33 1.25-2.72 1.37-7.69.59-11.7-.69-3.49-.28-11.44-4.05-11.32-1.6.05-1.02 11.41-2.72 14.77-1.7 3.37-5.93 4.56-5.93 4.56s-.73-17.39-1.71-20.44-1.62-7.81-.57-11.59 4.86-6.29 6.09-11.64c1.23-5.35 6.99-42.33 6.99-42.33l23.46 4.35ZM1710.12 444.26s5.23 35.41 3.61 41.88c-2.25 8.98-5.7 25.97-4.88 28.46 2.26 6.85 12.91 21.21 12.91 21.21s2.16-1.39 2.46-2.7c.3-1.31-1.15-3.7-1.15-3.7l2.79 1.9s2.72-2.17 1.58-4.83c-1.13-2.66-5.02-7.22-5.2-10.77-.18-3.55-1.81-14.65 3.36-14.4 3.39.16.73 9.22 2.24 12.68s4.78 3.09 4.78 3.09 2.55-11.67 3.38-16.3c.57-3.15 2.05-7.71 1.21-11.54-.84-3.83-4.5-6.55-5.43-11.96-.93-5.41 5.09-34.17 5.09-34.17l-26.77 1.16h.02Z"
        style={{
          fill: '#ebc88b',
        }}
      />
      <path
        d="M1798.49 700.41s.19.84.49 2.25c1.1 5.11 3.7 17.62 4.06 23.73.46 7.79-3.19 19.48-3.19 19.48l-27.32-4.33s6.83-20.78 6.37-30.74c-.46-9.96-3.64-15.15-3.64-15.15l23.22 4.76Z"
        style={{
          fill: '#4f4e47',
        }}
      />
      <path
        d="M1848.85 464.48s9.74 27.48 18.68 69.58c8.94 42.1 6.69 68.65 6.04 75.94-1.02 11.36-.03 35.77 4 61.29 4.02 25.51-4.55 51.34-4.55 51.34s-3.58 5.53-13.86 6.38c-10.29.85-16.99-.85-16.99-.85s-2.6-10.59-6.62-16.55c-4.02-5.95-23.5-57.11-28.42-73.69s-6.8-73.7-9.04-71.57 4.26 31.23 2.92 60.57-4.47 56.98-3.58 68.04 3.13 27.64 3.13 27.64-7.6 1.28-16.55 2.13c-8.94.85-14.76 0-14.76 0s-13.97-10.21-18.44-23.39-10.92-46.1-15.39-64.81-5.07-64.89-6.86-86.15 5.37-97.8 5.37-97.8l114.93 11.91h-.01Z"
        style={{
          fill: '#284f4f',
        }}
      />
      <path
        d="M1860.63 712.97c13.41 1.82 12.2 7.25 13.92 10.51 1.72 3.26 13.92 26.47 15.63 31s2.67 12.33 2.1 13.78c-.57 1.45-10.68 3.99-21.73 3.63-11.06-.36-16.97-.18-20.59-1.81s.76-11.6.76-18.13-4-11.78-4.77-18.31c-.76-6.53-.95-10.15-.95-10.15s5.34-.91 6.1-3.26c.76-2.36 1.53-8.34 9.53-7.25Z"
        style={{
          fill: '#c6a4c9',
        }}
      />
      <g
        style={{
          clipPath: 'url(#league-d)',
        }}
      >
        <path
          d="M1848.43 749.22s-1.14 9.25 5.53 10.51c6.67 1.27 13.15.54 19.64.73s12.77.36 14.11-1.45c1.33-1.81 4.77-7.07 4.77-7.07l6.48 15.95s-23.07 17.77-23.64 17.77-29.93-9.79-29.93-9.79l-2.67-14.68 5.72-11.96Z"
          style={{
            fill: '#e2e6ea',
          }}
        />
      </g>
      <path
        d="M1787.17 711.26c9.52-.71 10.29 7.25 13.15 8.16s4 3.44 4.58 9.79c.57 6.34 4.58 27.19 3.62 31.54-.95 4.35-2.1 5.98-7.82 5.98s-25.17-.54-29.93-.54-5.72-5.08-5.34-11.42c.38-6.34 5.15-17.77 7.63-23.57s.76-9.25 2.86-12.69 4-6.71 11.25-7.25Z"
        style={{
          fill: '#c6a4c9',
        }}
      />
      <g
        style={{
          clipPath: 'url(#league-e)',
        }}
      >
        <path
          d="M1810.04 746.61s-1.91 8.52-6.48 9.25c-4.58.73-24.78.54-30.69-.36-5.91-.91-8.58-8.34-8.58-8.34l-1.53 27.92 49.38 1.81 2.1-23.93-4.19-6.34h-.01Z"
          style={{
            fill: '#e2e6ea',
          }}
        />
      </g>
      <path
        d="M1766.5 272.67s5.37 24.41 2.73 31.2-10.97 6.57-10.97 6.57l13.95 39.78 62.22-8.86-1.13-34.88s-18.58-2.03-22.33-10.2c-3.76-8.17-.06-21.61-.06-21.61l-44.4-2.01Z"
        style={{
          fill: '#ebc88b',
        }}
      />
      <g
        style={{
          clipPath: 'url(#league-f)',
        }}
      >
        <path
          d="M1764.41 304.88s16.27 12.2 32.54 9.35c16.27-2.85 24.4-13.83 24.4-13.83l13.42-.41-47.18 69.95-38.64-55.31 15.46-9.76Z"
          style={{
            fill: '#fdd900',
          }}
        />
      </g>
      <path
        d="M1783.46 279.98c2.37-1.41 2.62.07 3.94 0 1.45-.07 1.65-1.62 5.03.23 3.66 1.99 4.64 1.47 4.9 3.18.53 3.56-2.97 8.75-8.61 9.25-4.96.44-11.35-4.88-10.2-8.8.67-2.26 1.84-2 4.93-3.85Z"
        style={{
          fill: '#e29b7b',
        }}
      />
      <path
        d="M1773.03 258.97c-1.87.7-2.66 2.4-1.9 4.22.75 1.81 2.29 2.35 4 1.81 1.84-.58 2.81-2.5 2.08-4.39-.61-1.59-2.25-2.35-4.18-1.63Z"
        style={{
          fill: '#235a96',
        }}
      />
      <path
        style={{
          fill: '#235a96',
        }}
        d="m1767.64 262.27 7.9-1.6-2.56-1.66-5.73 1.48.39 1.78zM1798.55 258.03c1.76.95 2.02 2.69 1.03 4.37-1 1.69-2.9 2.13-4.64 1.29-1.91-.92-2.06-3.29-1.16-4.73.75-1.22 2.96-1.92 4.77-.94Z"
      />
      <path
        style={{
          fill: '#235a96',
        }}
        d="m1803.46 260.61-7.35-1.04 1.5-1.76 6.12 1.1-.27 1.7z"
      />
      <path
        d="M1792.79 253.32s4.87.33 7.86 1.68 4.58 2.91 4.58 2.91l.82-1.32s.06-2.05-4.31-4.14c-2.28-1.08-8.92-1.89-8.92-1.89l-.04 2.75h.01ZM1777.23 254.57s-4.1.64-7.15 2c-3.04 1.36-3.38 3.02-3.38 3.02l-1.89-.71s.37-2.87 4.12-5.01c2.22-1.27 8.28-1.88 8.28-1.88l.02 2.58Z"
        style={{
          fill: '#e8af34',
        }}
      />
      <path
        d="M1722.26 328.89s10.48 71.18 9.36 98.11c-1.13 26.93-4.95 33.6-9.67 57.55-4.17 21.15 5.35 34.95 5.35 34.95l4.04 16.08s44.22-1.87 72.96-4.86 67.56-17.33 67.56-17.33l-1.35-17.7s8.8-4.06 6.09-23.02c-6.99-48.95-20.32-145.37-25.08-152.43-6.2-9.21-28.67-18.19-28.67-18.19s-7.66 9.25-14.61 18.77-13.27 24.92-13.27 24.92-10.23-13.43-20.08-22.06-19.67-19.51-19.67-19.51l-32.97 24.71h.01Z"
        style={{
          fill: '#284f4f',
        }}
      />
      <g
        style={{
          clipPath: 'url(#league-g)',
        }}
      >
        <path
          d="M1686.77 521.87s84.81-4.51 110.19-6.85c48.6-4.47 89.83-23.76 89.83-23.76l-.37 41.12s-164.67 33.82-164.67 31.15-34.97-41.67-34.97-41.67h-.01Z"
          style={{
            fill: '#4f6a6a',
          }}
        />
      </g>
      <path
        d="M1832.96 325.15s18.12 89.78 22.27 108.51c4.15 18.74 4.35 48.64 4.35 48.64l34.41 1.55s.19-14.22 4.82-18.73 9.95-12.17 6.91-31c-3.03-18.83-41.09-111.34-52.88-121.7s-15.53-6.38-22.99-3.12c-7.98 3.49 3.11 15.86 3.11 15.86ZM1741.77 311.43s-14.66 6.16-19.5 15.85c-5.28 10.56-7.02 92.08-5.56 92.03l35.84 6.89s10.78 4.85 5.39-44.18-16.17-70.59-16.17-70.59Z"
        style={{
          fill: '#284f4f',
        }}
      />
      <path
        style={{
          fill: '#c6a4c9',
        }}
        d="m1805.69 353.7 1.63 32.27 38.39-2.93-1.94-29.94-38.08.6z"
      />
      <path
        d="m1823.08 356.34-11.35.24.36 13.29s6.49-.34 6.49 3.67c0 3.1-6.52 2.59-6.52 2.59l.03 7.22s14.25.73 14.25-9.47c0-8.97-8.21-9.33-8.21-9.33l-.39-3.05 5.57-.21-.22-4.95h-.01ZM1827.39 356.4l1.09 25.91s15.45.05 14.74-13.97c-.67-13.38-15.83-11.95-15.83-11.95Z"
        style={{
          fill: '#ea683e',
        }}
      />
      <path
        d="m1712.74 486.17 22.83 2.19 2.7-16.18s8.91-10.15 8.94-18.28c.03-8.13 2.48-92.28 2.48-92.28s-24.48-42.05-27.35-32.01-24.99 112.65-22.7 124.53 11.06 20.37 11.06 20.37l2.04 11.65Z"
        style={{
          fill: '#284f4f',
        }}
      />
      <path
        d="m1739.43 308.01 15.54-6.65s16.72 19.33 23.41 24.16c6.69 4.83 13.42 10.22 13.42 10.22s13.59-10.31 16.44-14.91 14.61-18.77 14.61-18.77l14.25.04s3.72 1.49 1.11 8.92c-2.6 7.43-44.21 41.5-44.21 41.5l-54.32-38.22-.26-6.29Z"
        style={{
          fill: '#4f6a6a',
        }}
      />
      <path
        d="M1335.69 849.58c-.4 14.52-.41 14.32.21 20.14.6 5.64-1.64 18.78-1.64 18.78l29.49-3.98s-3.48-15.24-3.95-22.25 2.7-22.25 2.7-22.25l-26.81 9.57ZM1257.59 845.21c-1.89 16.37-1.9 16.09-.87 23.79 1.01 7.54-3.97 17.39-3.97 17.39l-27.5-1.95s4.79-14.3 5.8-21.35-.21-20.17-.21-20.17l26.75 2.29Z"
        style={{
          fill: '#4f4e47',
        }}
      />
      <path
        d="M1257.26 869.33c4.76-1.26 3.71 15.34 5.09 24.6 1.3 8.75 3 16.11 3 16.11s-21.92 6.5-24.19 9.42c-2.27 2.92-7.06 6.32-15.9 7.54-8.83 1.22-28.26-.49-29.77-3.16s-2.58-12.73 4.99-17.83c7.57-5.11 14.94-13.29 17.47-18.15 2.52-4.86 3.78-23.34 15.39-21.64s15.14 15.08 19.18 13.37 2.8-9.73 4.75-10.25h-.01Z"
        style={{
          fill: '#006835',
        }}
      />
      <g
        style={{
          clipPath: 'url(#league-h)',
        }}
      >
        <path
          d="M1188.92 918.73s5.55 1.95 7.57.24c2.02-1.7.76-3.85 5.3-3.85s5.05 4.58 11.36 5.07c6.31.49 11.1 1.22 17.91-3.4s7.57-7.78 14.89-10.94c7.32-3.16 20.94-13.62 20.94-13.62l.25 39.15-83.26 7.05s5.05-19.21 5.05-19.7h-.01Z"
          style={{
            fill: '#3fa25a',
          }}
        />
      </g>
      <path
        d="M1329.6 913.06s10.29 3.26 12.17 7.56 1.88 7.69 13.38 8.82 26.46-.65 30.45-3.14 2.53-11.72.21-16.03c-3.38-6.26-14.88-12.65-17.28-19.52-2.72-7.8-4.46-24.21-15.02-22.62-10.56 1.58-10.09 12.44-14.09 13.57-3.99 1.13-4.23-3.62-4.23-3.62s-4.7 20.36-4.7 26.7-.9 8.28-.9 8.28h.01Z"
        style={{
          fill: '#006835',
        }}
      />
      <g
        style={{
          clipPath: 'url(#league-i)',
        }}
      >
        <path
          d="M1328.62 893.48s.7 4.98 6.1 9.5 8.92 5.88 10.56 10.63 3.76 8.6 10.09 9.05c6.34.45 7.98-3.85 14.55-3.62 6.57.23 6.77 4.2 9.39 3.39 4.62-1.42 10.72-13.69 10.72-13.69l1.25 19.57-44.13 12.44-29.81-31.45 11.27-15.84v.02Z"
          style={{
            fill: '#009250',
          }}
        />
      </g>
      <path
        d="m1244.1 567.53 107.64-2.26s1.57 10.56 6.65 17.73c5.09 7.17 9.79 31.69 11.74 47.91 1.96 16.22 3.86 53.45 2.29 73.44s-.95 48.78-.17 60.85c.78 12.07 3.52 35.46 3.13 53.94s-9.63 43.75-9.63 43.75-8.47 6.33-15.91 6.33-16.92-1.83-16.92-1.83-10.92-38.22-9.74-63.87c1.17-25.65-4.19-58.94-12.02-83.45-7.83-24.52-12.9-32.9-12.9-32.9s-8.4 20.13-14.28 35.59c-5.87 15.47-7.09 40.78-7.8 46.73-1.33 11.16-2.8 43.89-5.15 54.45s-13.45 41-13.45 41-18.52 1.64-22.83 1.26c-4.31-.38-9.59-3.53-9.59-3.53s-5.63-31.44-7.58-47.28c-1.96-15.84 4.29-66.92 3.12-79.36-1.17-12.45-4.58-66.82-3.4-92.48 1.17-25.65 17.08-82.21 26.78-76.02h.02ZM1295.07 265.31c-7.36.26-10.09 6.5-15.9 8.19s-15-2.18-20.36 3.74c-5.36 5.92-3.48 10.42-5.72 13.81-2.23 3.38-8.33 2.76-11.46 12.49-3.04 9.45-.76 11.36-.51 16.02.26 4.93-4.31 11.75-4.84 18.3-.72 8.9 7.75 12.25 10.27 17.29 2.87 5.75 4.19 16.58 9.9 20.52 8.92 6.16 18.95 7.77 22.97 12.43 4.02 4.65 2.53 1.38 18.83 3.06 13.26 1.37 14.24-5.69 18.71-6.54s11.45-3.35 17.51-9.49c6.85-6.93 5.27-16.07 9.29-19.03s10.56-8.54 10.56-14.89-5.26-12.89-5.33-16.91c-.1-5.82 3.83-9.13-.08-19.57-3.65-9.74-10.1-10.96-13.68-14.34-3.57-3.38.64-9.67-6.01-13.92-9.34-5.99-10.72-1.27-16.09-4.23-5.36-2.96-5.99-7.35-18.06-6.92Z"
        style={{
          fill: '#4f4e47',
        }}
      />
      <path
        d="M1273.6 354.35s4.49 18.93 3.63 27.93c-1.43 14.93-19.43 28.41-19.43 28.41l38.85 15.69 43.07-17.02s-20.7-12.65-23.79-24.6c-3.09-11.95.09-27.25.09-27.25l-42.42-3.16Z"
        style={{
          fill: '#c48648',
        }}
      />
      <path
        d="M1264.99 345.7c0 9.88 6.32 21.85 12 28.04 5.7 6.2 9.97 9.48 21.03 8.46 8.53-.78 14.64-3.02 18.02-8.01 4.55-6.73 15.24-21.27 13.3-32.67-1.12-6.58-7.83-15.87-10.47-21.28-4.26-8.74-6.25-13.65-22.57-12.96-14.27.61-19.16 2.64-22.72 13.3-3.21 9.63-8.59 17.42-8.59 25.12Z"
        style={{
          fill: '#c48648',
        }}
      />
      <path
        d="M1292.05 357.87c2.83-.76 4.71-.03 5.77-.11 1.16-.08 2.14-1.19 5.22-1.09 3.9.12 6.25 3.21 6.44 4.2.35 1.9-.79 4.43-1.36 5.56-1.45 2.88-2.95 5.49-9.26 5.83-5.17.28-6.79-1.53-9.52-4.31-1.57-1.61-3.89-4.02-4.32-6.17-.44-2.15 4.21-3.17 7.04-3.92h-.01Zm-.84 5.37c.24.82 5.07 3.16 8.15 3.16s4.89-2.75 4.59-3.76c-.24-.82-1.91-.09-5.92.25-5.5.46-6.97-.15-6.82.35Z"
        style={{
          fill: '#ad5850',
        }}
      />
      <path
        d="M1268.33 336.78s-10.16-7.39-10.56.76c-.4 8.15 2.49 15.91 5.15 15.91 3.17 0 7.52-5.04 7.52-5.04l-2.11-11.62ZM1323.76 338.11s11.47-7.93 11.86.22c.4 8.15-2.49 15.91-5.15 15.91-3.17 0-7.52-5.04-7.52-5.04l.8-11.08h.01Z"
        style={{
          fill: '#c48648',
        }}
      />
      <path
        d="M1282.56 333.72c-2.18.14-3.62 1.7-3.4 3.83s1.66 2.91 3.62 2.91c2.32 0 3.55-1.48 3.55-3.69 0-1.56-1.52-3.19-3.76-3.05h-.01Z"
        style={{
          fill: '#4f4e47',
        }}
      />
      <path
        style={{
          fill: '#4f4e47',
        }}
        d="m1277.21 336.29 9.65-2.77-.94-2.06-9.32 2.89.61 1.94zM1309.27 333.32c2.18.14 3.62 1.7 3.4 3.83-.22 2.13-1.66 2.91-3.62 2.91-2.32 0-3.55-1.48-3.55-3.69 0-1.56 1.52-3.19 3.76-3.05h.01Z"
      />
      <path
        style={{
          fill: '#4f4e47',
        }}
        d="m1315.13 335.4-9.55-1.8.78-2.33 9.18 1.86-.41 2.27z"
      />
      <path
        d="M1303.41 329.4s5.66-1.93 9.22-1.52c3.56.41 6.37 2.41 6.37 2.41l.45-1.73s-2.07-3.36-7.31-4.08c-2.72-.37-9.59 2.2-9.59 2.2l.85 2.71h.01ZM1287.23 327.9s-5.93-.35-9.17 1.18-5.31 4.67-5.31 4.67l-.98-1.49s.93-4.19 5.66-6.55c2.46-1.23 9.84-.91 9.84-.91l-.04 3.1Z"
        style={{
          fill: '#3a4b36',
        }}
      />
      <path
        d="m1218.37 603.65 9.8 31.23s5.75-8.8 10.99-14.77c5.24-5.98 6.99-14.03 6.99-14.03s-2.65-.84-8.13-4.91c-4.9-3.65-4.65-7.7-4.65-7.7l-15 10.18ZM1376.63 609.56l-11.43 27.51s-4.9-5.22-9.93-11.36-9.35-13.03-9.35-13.03 6.16-4.74 9.47-7.95c3.21-3.12 9.47-8.71 9.47-8.71l11.77 13.54Z"
        style={{
          fill: '#c48648',
        }}
      />
      <path
        d="M1407.79 539.93c-3.17-20.08-21.37-106.63-35.63-120.58-11.47-11.22-21.16-15.22-25.5-17.13-9.44-4.16-27.98-12.13-27.98-12.13s-10.27 5.61-21.4 6.06-22.97-4.74-22.97-4.74-12.55 5.21-21.05 9.45c-5.38 2.69-20.34 6.92-29.51 18.65-7.95 10.18-43 104.39-42.69 124.71.75 49.81 36.65 81.99 36.65 81.99s6.83-3.27 13.49-12.85c6.06-8.71 11-10.34 11-10.34s29.73 5.5 51.99 3.56c19.05-1.66 42.91-3.6 58.73-4.98 2.99 1.35 7.96 4.21 13.19 9.84 3.85 4.15 11.56 10.92 11.56 10.92s37.81-33.82 30.13-82.44h-.01Z"
        style={{
          fill: '#f4d027',
        }}
      />
    </svg>
  )
}

export default LeagueStart